import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import OrdersTable from '../../containers/Tables/Admin/OrdersTable';
import ContextSnackbar from '../../components/Snackbar';

import colors from '../../styles/Colors';
import { displayFlex } from '../../styles/Mixins';

const AdminOrdersBase = props => {
  const { className } = props;

  return (
    <AdminOrdersSection className={className} isMobile={isMobile}>
      <div className="page-wrapper">
        <ContextSnackbar />
        <OrdersTable {...props} />
      </div>
    </AdminOrdersSection>
  );
};

const AdminOrdersSection = styled.section`
  .page-wrapper {
    margin: 85px 0 50px;
    min-width: 1130px;
    height: 100%;

    ${({ isMobile }) =>
      isMobile &&
      `
      margin: 51px 0 50px;
      min-width: 100%;
    `}
  }

  &__Page-Title {
    ${displayFlex}
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  // &__Header {
  //   &&& {
  //     text-align: left;
  //     margin: 0 20px 0 0;
  //   }
  // }
  //
  // &__Table-On {
  //   &&& {
  //     width: 100%;
  //     border: 1px solid ${colors.secondary};
  //     border-radius: 0;
  //     background-color: ${colors.secondary};
  //     color: ${colors.white};
  //   }
  // }
  //
  // &__Table-Off {
  //   &&& {
  //     width: 100%;
  //     border: 1px solid ${colors.secondary};
  //     border-radius: 0;
  //     background-color: ${colors.white};
  //     color: ${colors.secondary};
  //   }
  // }
`;

export default AdminOrdersBase;
